import { useTranslation } from 'react-i18next';

import { CustomButton } from '../../../../UiComponentsLibrary/CustomButton';
import { ButtonConfig } from '../config/buttonConfig';
import { BookingStep } from '../constants/DetailedBookingConstants';

interface ModalFooterProps {
  buttonConfig: Record<BookingStep, ButtonConfig[]>;
  currentStep: BookingStep;
}

const ModalFooter = ({ buttonConfig, currentStep }: ModalFooterProps) => {
  const { t } = useTranslation();
  return (
    <>
      {buttonConfig[currentStep].map((button) => {
        const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
          event?.preventDefault();
          button.handleOnClickCb?.();
        };
        return (
          <CustomButton
            key={button.id}
            id={button.id}
            text={t(button.text)}
            backgroundColor={button.backgroundColor}
            handleOnClickCb={handleClick}
            disabled={button.disabled}
          />
        );
      })}
    </>
  );
};

export default ModalFooter;
